"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityPropertyRequestFailedError = void 0;
class EntityPropertyRequestFailedError extends Error {
    constructor({ entityType, propertyKey, operation, status }) {
        super(`The request to ${operation} the ${entityType.toLowerCase()} property (${propertyKey}) failed with status (${status}).`);
    }
}
exports.EntityPropertyRequestFailedError = EntityPropertyRequestFailedError;
